// extracted by mini-css-extract-plugin
module.exports = {"icon":"_1c38v4VlXU6WFVli","svg":"XybsSSKsbbHKEULf","children":"_3oeiCbmFLHaiRlRK"};